import type { Locale } from './Locale';

import GettextCatalogJSON from '../../resources/i18n/translations.json';

import Gettext, { type GettextInterface, type LocaleData } from '@indeed/indeed-gettext';

type CatalogData = { [locale: string]: LocaleData };

const Catalog: CatalogData = GettextCatalogJSON satisfies CatalogData;

// turn obj to string
function serializeLocale(locale: Locale): string {
    if (!locale.language) {
        return 'en';
    }
    return locale.country ? `${locale.language}_${locale.country}` : locale.language;
}

export function emptyCatalog(): LocaleData {
    return { '': {} };
}

export function loadCatalog(locale: Locale): LocaleData {
    const localeString = serializeLocale(locale);
    const catalog = Catalog[localeString];
    const fallBackCatalog = Catalog[locale.language];

    if (catalog === undefined && fallBackCatalog === undefined) {
        console.error(`No translations found for locale: ${localeString}`);
        return emptyCatalog();
    }

    return {
        ...(fallBackCatalog ?? {}),
        ...(catalog ?? {}),
    };
}

export function buildMockI18n(config: LocaleData = emptyCatalog()): GettextInterface {
    return Gettext(config);
}
